module.exports = __webpack_public_path__ + "static/media/sesame.e16c9386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/sesame.jpg
// module id = 134
// module chunks = 0